// #region module
export const PLURID_ROUTER_LOCATION_CHANGED = 'pluridrouterlocationchanged';
export const PLURID_ROUTER_LOCATION_STORED = 'pluridrouterlocationstored';
// #endregion module
